import type { TranslationTree } from '../../types';

export const signals: TranslationTree = {
  signals: {
    nav: 'Signals',
    page: {
      breadcrumb: 'Signal Visualization',
      title: 'Signal Visualization',
      description:
        'Fetch and explore raw InfluxDB signals for any machine, over a free time range — no prediction involved.',
    },
    source: {
      label: 'Signal source',
      tags: {
        active: 'active now',
        activeAt: 'active · {{time}}',
        historyOnly: 'history only',
        notFound: 'not in the database',
        linkedTo: 'linked to {{machine}}',
        noSource: 'no source',
      },
    },
    panel: {
      badge: 'Context',
      machineLabel: 'Machine',
      machinePlaceholder: 'Select a machine',
      unlinkedSources: 'Unlinked sources (admins)',
      noSignalSource:
        'This machine has no signal source, so there are no signals to show. Link one in Workshop → Machines.',
      machineStatus: {
        lastActivity: 'Last activity: {{date}}',
        noData: 'No data for this machine',
      },
      signalsLabel: 'Signals',
      signalsCounter: '{{count}} / {{max}} selected',
      signalsEmptyMachine: 'Select a machine to see the available signals',
      signalsLoading: 'Loading signals…',
      groups: {
        spindle: 'Spindle',
        x: 'X axis',
        y: 'Y axis',
        z: 'Z axis',
        b: 'B axis',
        c: 'C axis',
        lubrication: 'Lubrication',
        other: 'Other',
      },
      timeRangeLabel: 'Time range',
      chips: {
        '15m': '15 min',
        '1h': '1 h',
        '8h': '8 h',
        '24h': '24 h',
        '7d': '7 d',
        custom: 'Custom',
      },
      customStartLabel: 'Start',
      customEndLabel: 'End',
      lastActivityShortcut: 'Last activity (1 h)',
      rangeError: {
        invalid: 'Invalid dates.',
        order: 'The end date must be after the start date.',
        tooLong: 'The range cannot exceed 90 days.',
      },
      toolIdLabel: 'Tool (optional)',
      toolIdPlaceholder: 'Tool ID',
      loadButton: 'Load signals',
    },
    tags: {
      spindlePwr: 'Spindle power',
      xFollErr: 'X follow error',
      yFollErr: 'Y follow error',
      zFollErr: 'Z follow error',
    },
    chart: {
      badge: 'Signals',
      helper: '{{visible}} of {{total}} channels · {{samples}} samples · {{passes}} passes',
      helperAggregated: '{{visible}} of {{total}} channels · {{window}} ms window · {{samples}} pts',
      viewStack: 'Stack',
      viewOverlay: 'Overlay',
      viewLabel: 'Chart layout',
      peak: 'peak {{value}}',
      timeAxisLabel: 'Time (s)',
      chipsGroupLabel: 'Toggle channel visibility',
      passLabel: 'pass {{passIndex}}',
      errorTitle: 'Signal unavailable',
      errorRetry: 'Retry',
      emptyWindowTitle: 'No data in this period',
      emptyWindowHint:
        'This machine has no signals in the selected window. Try the "Last activity" shortcut in the panel to jump to its most recent data.',
    },
    empty: {
      title: 'Pick a machine and load signals',
      description: 'Select a machine and a time range, then click Load signals.',
    },
  },
};
